import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";

const COLS = [
  { title: "Explore", links: [["Community", "/community"], ["Find a company", "/companies"], ["Properties", "/properties"], ["Post a job", "/post-a-job"]] },
  { title: "For business", links: [["List your company", "/for-businesses"], ["How it works", "/how-it-works"], ["Register a business", "/business/register"]] },
  { title: "Company", links: [["About", "/about"], ["Contact", "/contact"], ["Community guidelines", "/community-guidelines"]] },
  { title: "Legal", links: [["Terms", "/terms"], ["Privacy", "/privacy"]] },
];

export const Footer = () => (
  <footer className="bg-[#0B1733] text-white mt-24" data-testid="site-footer">
    <div className="propora-container py-16">
      <div className="grid grid-cols-1 md:grid-cols-5 gap-10">
        <div className="md:col-span-1">
          <Logo light />
          <p className="mt-4 text-sm text-white/60 leading-relaxed max-w-[220px]">
            Dubai's property network. Your property. Your people. One place.
          </p>
        </div>
        {COLS.map((col) => (
          <div key={col.title}>
            <h4 className="text-white font-display font-bold text-sm uppercase tracking-wider mb-4">{col.title}</h4>
            <ul className="space-y-2.5">
              {col.links.map(([label, to]) => (
                <li key={to}>
                  <Link to={to} className="text-sm text-white/65 hover:text-[#4fd1c5] transition-colors">{label}</Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div className="mt-14 pt-6 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-3 text-xs text-white/45">
        <span>© 2026 Real&State (working name). Demo content is illustrative only.</span>
        <span>Real&State is not a licensed broker. Trade-licence checks do not imply government endorsement.</span>
      </div>
    </div>
  </footer>
);
